import { render, staticRenderFns } from "./AdminBespokeSearch.vue?vue&type=template&id=2ccb807c&"
import script from "./AdminBespokeSearch.vue?vue&type=script&lang=js&"
export * from "./AdminBespokeSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports